export interface OfferSummary {
  id: number;
  type: string;
  name: string;
  description: string;
  startAt: Date;
  endAt: Date;
}

export const offerSummaryFromResponse = (responseData: any): OfferSummary => ({
  id: responseData.id,
  type: responseData.type,
  name: responseData.name,
  description: responseData.description,
  startAt: new Date(responseData.start_at),
  endAt: new Date(responseData.end_at),
});
